import { render, staticRenderFns } from "./PersonSeller.vue?vue&type=template&id=06929650&scoped=true&"
import script from "./PersonSeller.vue?vue&type=script&lang=js&"
export * from "./PersonSeller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06929650",
  null
  
)

export default component.exports